import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-body',
    templateUrl: './modal-body.component.html',
    standalone: false
})
export class ModalBodyComponent {

}
